// 현장일지 임시 저장 — 이 브라우저에만 남는다(현장·날짜당 한 벌) · 저장소가 막히면 조용히 없는 셈 친다.

import { PROJECT_LOG_KINDS, type ProjectLogKind } from "@buildpy/core/modules/project/types";

export interface LogDraft {
  kind: ProjectLogKind;
  body: string;
  phaseId: string;
  crew: string;
  weather: string;
}

export interface DraftStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

export const logDraftKey = (projectId: string, logDate: string): string => `buildpy:log-draft:${projectId}:${logDate}`;

export const browserDraftStore = (): DraftStore | null => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

const textOf = (value: unknown): string => (typeof value === "string" ? value : "");

// 본문이 빈 초안은 없는 것으로 본다 — 종류만 고른 채 닫은 시트를 되살리지 않는다.
export const readLogDraft = (store: DraftStore | null, key: string): LogDraft | null => {
  if (!store) return null;
  try {
    const raw = store.getItem(key);
    if (!raw) return null;
    const value = JSON.parse(raw) as Record<string, unknown>;
    const body = textOf(value.body);
    if (body.trim() === "") return null;
    const kind = PROJECT_LOG_KINDS.find((k) => k === value.kind) ?? "NOTE";
    return { kind, body, phaseId: textOf(value.phaseId), crew: textOf(value.crew), weather: textOf(value.weather) };
  } catch {
    return null;
  }
};

export const writeLogDraft = (store: DraftStore | null, key: string, draft: LogDraft): boolean => {
  if (!store) return false;
  try {
    store.setItem(key, JSON.stringify(draft));
    return true;
  } catch {
    return false;
  }
};

export const clearLogDraft = (store: DraftStore | null, key: string): void => {
  if (!store) return;
  try {
    store.removeItem(key);
  } catch {
    // 지우지 못해도 다음 저장이 덮는다.
  }
};
